import { render, staticRenderFns } from "./RightChannel.vue?vue&type=template&id=0bbdddc4"
import script from "./RightChannel.vue?vue&type=script&lang=js"
export * from "./RightChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports